export const VEHICLE_TYPE_MAPPER = {
  'Passenger Vehicle': 'PV',
  'Light Truck': 'LT',
  'Motorcycle': 'M',
  'Trailer': 'T',
  'Motorhome': 'O',
  'Cab & Chassis': 'CC',
  'Sports Utility Vehicle': 'SUV',
  'Multipurpose Passenger Vehicle': 'SUV',
  'Truck': 'LT'
};

export const VEHICLE_TYPE = {
  "Passenger Vehicle": "Passenger Vehicle",
  "Light Truck": "Pickup Truck",
  "Motorcycle": "Motorcycle",
  "Sports Utility Vehicle": "Sports Utility Vehicle",
  "Multipurpose Passenger Vehicle": "Sports Utility Vehicle",
  "Truck": "Truck"
}

export const FUEL_TYPE = {
  "G": "Gas",
  "E": "Electric",
  "Dl": "Diesel",
  "H": "Hybrid"
}

export const PLATE_TYPE = {
  "Commercial": "Commercial",
  "Regular": "Regular"
}

export const PLATE_TYPE_FULL_TO_SHORT = {
  "Commercial": "C",
  "Regular": "R"
}

export const TRANSACTION_TYPE = {
  "Purchase": "Purchase",
  "Refinance": "Refinance"
}

export const TRANSACTION_TYPE_MAPPER = {
  "Purchase": "P",
  "Refinance": "RE"
}

export const TITLE_STATUS = {
  "MSO": "MSO (New Vehicle)",
  "T": "Used Vehicle"
}
